import React from 'react'

class NavMeineAusbildung extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path
          fill="#FFF"
          fillRule="evenodd"
          d="M10.53.47l9 9a.75.75 0 0 1-.53 1.28h-1.25v9h-5.5V18h-.002l.002-3.25h-4.5v5h-5.5v-9H1a.75.75 0 0 1-.53-1.28l9-9a.75.75 0 0 1 1.06 0zm5.72 10.28H3.75v7.5h2.5v-5h7.5v5h2.5v-7.5zM10 2.06L2.81 9.25h14.38L10 2.06z"
        />
      </svg>
    )
  }
}

export default NavMeineAusbildung
